import type { EnrichedHerdRecord, OperationType } from "shared/types";

export const LIST_FARM_ENRICHED_HERD_RECORDS =
  "LIST_FARM_ENRICHED_HERD_RECORDS";
export const LIST_OPERATION_TYPES = "LIST_OPERATION_TYPES";

export type MovementsDispatchAction =
  | {
      type: typeof LIST_FARM_ENRICHED_HERD_RECORDS;
      payload: { records: EnrichedHerdRecord[] };
    }
  | {
      type: typeof LIST_OPERATION_TYPES;
      payload: { operationTypes: OperationType[] };
    };

export const listFarmEnrichedHerdRecords = (
  records: EnrichedHerdRecord[]
): MovementsDispatchAction => {
  return {
    type: LIST_FARM_ENRICHED_HERD_RECORDS,
    payload: { records },
  };
};

export const listOperationTypes = (
  operationTypes: OperationType[]
): MovementsDispatchAction => {
  return {
    type: LIST_OPERATION_TYPES,
    payload: { operationTypes },
  };
};
